import React from 'react';
import RightSlider from '../../AdsSlider/RightSlider_300x600';

const AsideRight = () => {
    const today = Date.now();
    const dateNow = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(today)
    
    return (
        <>
        <div class="asides column col-md-2 p-0 mb-1">
                        <div class="aside aside-right pt-2">
                            <div class="aside-ads-right m-2">
                                <div class="ads-right-header">
                                    <h1 class="display-4 alert" role="alert"><i class="fa fa-bullhorn fa-x1"></i> Latest Updates</h1>
                                </div>
                                <hr class="mt-4"/>
                                    <div class="campaign mt-4 pb-2">
                                        <div class="bulletin pt-3">                                            
                                            <p>
                                                Sorry for the inconvenience, site is still in progress! 
                                                <br/><br/>
                                            <span class="date">{dateNow}</span>&nbsp;&nbsp;
                                            <span class="date">Admin</span>
                                            </p>
                                            
                                        </div>
                                    </div>
                                <a href="#" class="campaign-link">
                                    <div class="campaign mt-4 pb-2">
                                        <div class="campaign-img mt-4">
                                            <RightSlider />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            </div>
                    </div>            
        </>
    )
};

export default AsideRight;
